import { App } from 'vue';
import VueLazyLoad from 'vue3-lazyload'
  
/**
 * 注册全局自定义指令
 * @param app
 */
export function lazyLoadDirective(app: App) {
  // 图片懒加载
  app.use(VueLazyLoad )
  
}
